
(function () {
  document.querySelectorAll('.hero.loading, .hero.loading--delayed').forEach(function (hero) {
    hero.classList.remove('loading', 'loading--delayed');
    hero.classList.add('loaded');
  });
  document.querySelectorAll('.slideshow__slide').forEach(function (slide, i) {
    if (i === 0) slide.classList.add('is-selected');
  });

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  var end = Date.now() + 7200000;
  function tick() {
    var diff = Math.max(0, Math.floor((end - Date.now()) / 1000));
    if (diff <= 0) { end = Date.now() + 7200000; diff = 7200; }
    var h = document.getElementById('everly-hours-q8m2');
    var m = document.getElementById('everly-minutes-q8m2');
    var s = document.getElementById('everly-seconds-q8m2');
    if (!h) return;
    h.textContent = pad(Math.floor(diff / 3600));
    m.textContent = pad(Math.floor((diff % 3600) / 60));
    s.textContent = pad(diff % 60);
  }
  tick();
  setInterval(tick, 1000);

  var html = document.documentElement;
  function openDrawer(id) {
    document.querySelectorAll('.drawer').forEach(function (d) { d.classList.remove('drawer--is-open'); });
    var el = document.getElementById(id);
    if (el) el.classList.add('drawer--is-open');
    html.classList.add('js-drawer-open');
    document.body.classList.add('js-drawer-open');
  }
  function closeDrawers() {
    document.querySelectorAll('.drawer').forEach(function (d) { d.classList.remove('drawer--is-open'); });
    html.classList.remove('js-drawer-open');
    document.body.classList.remove('js-drawer-open');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-drawer-open-nav')) { e.preventDefault(); openDrawer('NavDrawer'); }
    if (e.target.closest('.js-drawer-open-cart')) { e.preventDefault(); openDrawer('CartDrawer'); refreshCart(); }
    if (e.target.closest('.js-drawer-close')) { e.preventDefault(); closeDrawers(); }
  });

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var empty = document.querySelector('.drawer__cart-empty');
      var items = document.querySelector('[data-products]');
      var sub = document.querySelector('[data-subtotal]');
      if (sub) sub.textContent = money(cart.total_price);
      if (!items) return;
      if (!cart.item_count) {
        items.innerHTML = '';
        if (empty) empty.style.display = '';
        return;
      }
      if (empty) empty.style.display = 'none';
      items.innerHTML = cart.items.map(function (item) {
        return '<div class="cart__item" style="display:flex;gap:12px;padding:12px 0;border-bottom:1px solid #eee">'
          + (item.image ? '<img src="' + item.image + '" alt="" width="72" height="72">' : '')
          + '<div><div>' + item.product_title.replace(/®/g, '') + '</div><div>' + item.quantity + ' × ' + money(item.price) + '</div></div></div>';
      }).join('');
      var bubble = document.querySelector('.cart-link__bubble');
      if (bubble) bubble.textContent = cart.item_count;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.add-to-cart-button, .prdoff-add-to-cart');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var idEl = document.getElementById('ev-variant-id');
    var id = idEl ? idEl.value : '';
    if (!id) return;
    var scope = btn.closest('.box_2, .prdoff-bundle-offers, .shopify-section') || document;
    var active = scope.querySelector('.offer-box.active, .prdoff-offer-box.active');
    var qty = active ? parseInt(active.getAttribute('data-quantity'), 10) || 1 : 1;
    btn.classList.add('loading_hk');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      btn.classList.remove('loading_hk');
      openDrawer('CartDrawer');
      refreshCart();
    }).catch(function () {
      btn.classList.remove('loading_hk');
    });
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    if (!window.jQuery) return;
    var $ = window.jQuery;
    $('.product-slider, .testimonial-slider, .benefits-layout').each(function () {
      if ($(this).hasClass('slick-initialized')) return;
      if ($(this).children().length < 2) return;
      try {
        $(this).slick({ dots: true, arrows: true, adaptiveHeight: true });
      } catch (err) {}
    });
  });

  document.addEventListener('click', function (e) {
    var q = e.target.closest('.faq-questions');
    if (!q) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var answer = q.nextElementSibling;
    if (!answer || !answer.classList.contains('faq-answers')) return;
    var willOpen = answer.style.display !== 'block';
    document.querySelectorAll('.faq-questions').forEach(function (btn) {
      var panel = btn.nextElementSibling;
      if (panel && panel.classList.contains('faq-answers')) panel.style.display = 'none';
      var icon = btn.querySelector('.toggle-icons');
      if (icon) icon.textContent = '+';
      btn.classList.remove('active');
    });
    if (willOpen) {
      answer.style.display = 'block';
      var icon = q.querySelector('.toggle-icons');
      if (icon) icon.textContent = '\u2013';
      q.classList.add('active');
    }
  }, true);
})();
